export default "<h3>May 5, 2019</h3>\r\n<p>Update 0.92 fixes some bugs.</p>";